/**
 * Camera-off UI policy — keeps patient local mute and nurse remote mute independent.
 * Used by patient web + smoke tests. Nurse RN mirrors the same rules in WebRTCService.
 */

/**
 * Should patient UI show/hide NURSE (remote) camera-off overlay?
 * @returns {boolean|null} true=off, false=on, null=ignore message
 */
function resolveNurseRemoteCameraOff(msg, myUserId) {
    if (!msg || typeof msg !== 'object') {
        return null;
    }
    const sender = msg.sender;
    if (sender && myUserId && String(sender) === String(myUserId)) {
        return null; // room echo of own announce
    }
    const payload = msg.message && typeof msg.message === 'object' ? msg.message : msg;
    if (!payload || typeof payload !== 'object') {
        return null;
    }
    // Patient's own camera announce must never drive nurse overlay
    if (payload.patientCameraState === true) {
        return null;
    }
    if (payload.type === 'audio') {
        return null;
    }
    // Preferred: nurse explicit camera flag
    if (payload.nurseCameraState === true && typeof payload.cameraOff === 'boolean') {
        return !!payload.cameraOff;
    }
    return null;
}

/**
 * Should nurse app show/hide PATIENT (remote) camera-off overlay?
 * @returns {boolean|null} true=off, false=on, null=ignore message
 */
function resolvePatientRemoteCameraOff(msg, myUserId) {
    if (!msg || typeof msg !== 'object') {
        return null;
    }
    const sender = msg.sender;
    if (sender && myUserId && String(sender) === String(myUserId)) {
        return null;
    }
    const payload = msg.message && typeof msg.message === 'object' ? msg.message : msg;
    if (!payload || typeof payload !== 'object') {
        return null;
    }
    // Nurse's own camera announce must never drive patient remote overlay on nurse app
    if (payload.nurseCameraState === true) {
        return null;
    }
    if (payload.type === 'audio') {
        return null;
    }
    if (payload.patientCameraState === true && typeof payload.cameraOff === 'boolean') {
        return !!payload.cameraOff;
    }
    return null;
}

/**
 * RMC onmute/onunmute — only remote stream may flip nurse overlay on patient.
 * @returns {boolean|null} true=off, false=on, null=ignore
 */
function shouldApplyRmcRemoteVideoMute(streamEvent, muteKind /* 'mute'|'unmute' */) {
    if (!streamEvent || streamEvent.type === 'local') {
        return null;
    }
    const key = muteKind === 'unmute' ? 'unmuteType' : 'muteType';
    const mediaType = streamEvent[key];
    if (mediaType === 'video' || mediaType === 'both') {
        return muteKind === 'mute';
    }
    return null;
}

module.exports = {
    resolveNurseRemoteCameraOff,
    resolvePatientRemoteCameraOff,
    shouldApplyRmcRemoteVideoMute,
};
